<div class="uk-animation-slide-left-small" uk-grid>
  <div class="uk-width-1-1">

    <h2 class="uk-heading-divider">Wallet Sweeper</h2>

    <div class="uk-width-1-1 nlt-page-intro">
      <p>
        This lets you collect all funds from all accounts in a given wallet and transfer them to any destination.
      </p>
      <p>
        Could be used to load a paper wallet into some of your existing accounts, transfer a wallet or even empty your existing Nault wallet and transfer it somewhere else.
      </p>
      <p>
        Even a mnemonic from a Ledger hardware wallet or other multicurrency wallets using BIP39/44 can be recovered using this tool.
      </p>
      <p>
        <strong>Please use with caution if you are using an external destination. Make sure you have access to the secret recovery seed on the receiving side!</strong>
      </p>
    </div>

    <div class="uk-card uk-card-default">
      <div class="uk-card-body">
        <div uk-grid>
          <div class="uk-width-1-1 narrow-div">
            <div class="uk-form-horizontal">
              <div class="uk-margin">
                <label class="uk-form-label" for="source-wallet">Source Wallet <span uk-icon="icon: info;" uk-tooltip title="The wallet to empty/sweep into the destination. WARNING: This wallet and all coresponding accounts will be emptied."></span></label>
                <div class="uk-form-controls">
                  <div uk-grid>
                    <div class="uk-width-1-1">
                      <div class="uk-inline uk-width-1-1">
                        <input [(ngModel)]="sourceWallet" class="uk-input uk-margin-small-bottom {{validSeed ? '':'uk-form-danger'}}" id="source-wallet" type="text" (ngModelChange)="seedChange(sourceWallet)" placeholder="Secret recovery seed, BIP39 seed, private key or 12,15,18,21,24-word secret recovery mnemonic" autocomplete="off">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="uk-width-1-1 narrow-div">
            <div class="uk-form-horizontal">
              <div class="uk-margin">
                <label class="uk-form-label" for="destination-account">Local Destination <span uk-icon="icon: info;" uk-tooltip title="Local accounts that can be used as destination for the swept funds. Make sure you are able to unlock your Nault wallet."></span></label>
                <div class="uk-form-controls">
                  <select class="uk-select" id="destination-account" [(ngModel)]="myAccountModel" (change)="setDestination(myAccountModel)">
                    <option *ngFor="let account of accounts" [value]="account.id">{{account.addressBookName ? account.addressBookName + ' - ' : '#' + account.index + ' - ' }} {{ account.id | squeeze }} ({{ account.balance | rai: 'mnano,true' | amountsplit: 0 }}{{ account.balance | rai: 'mnano,true' | amountsplit: 1 }} XNO)</option>
                    <option [value]="0">Custom Destination</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="customAccountSelected" class="uk-width-1-1 narrow-div">
            <div class="uk-form-horizontal">
              <div class="uk-margin">
                <label class="uk-form-label" for="custom-destination">Custom Destination <span uk-icon="icon: info;" uk-tooltip title="The deposit account for the sweps funds. Can be any remote account."></span></label>
                <div class="uk-form-controls">
                  <div uk-grid>
                    <div class="uk-width-1-1">
                      <div class="uk-inline uk-width-1-1">
                        <input [(ngModel)]="destinationAccount" class="uk-input uk-margin-small-bottom {{validDestination ? '':'uk-form-danger'}}" id="custom-destination" type="text" (ngModelChange)="destinationChange(destinationAccount)" placeholder="nano_abc..123">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="uk-width-1-1 narrow-div">
            <div class="uk-form-horizontal">
              <div class="uk-margin">
                <label class="uk-form-label" for="start-index">Start Index <span uk-icon="icon: info;" uk-tooltip title="The account index to start looking for funds. The first account in any wallet is usually 0. Ignored if using private key as source. The maximum number of indexes to check in each run is 100."></span></label>
                <div class="uk-form-controls">
                  <div class="uk-inline uk-width-1-1">
                    <input [(ngModel)]="startIndex" class="uk-input uk-margin-small-bottom {{validStartIndex ? '':'uk-form-danger'}}" id="start-index" type="text" maxLength="10" (ngModelChange)="startIndexChange(startIndex)" placeholder="0 to {{indexMax}}" autocomplete="off">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="uk-width-1-1 narrow-div">
            <div class="uk-form-horizontal">
              <div class="uk-margin">
                <label class="uk-form-label" for="end-index">End Index <span uk-icon="icon: info;" uk-tooltip title="The account index to stop looking for funds. The first account in any wallet is usually 0. Ignored if using private key as source. The maximum number of indexes to check in each run is 100."></span></label>
                <div class="uk-form-controls">
                  <div class="uk-inline uk-width-1-1">
                    <input [(ngModel)]="endIndex" class="uk-input uk-margin-small-bottom {{validEndIndex ? '':'uk-form-danger'}}" id="end-index" type="text" maxLength="10" (ngModelChange)="endIndexChange(endIndex)" placeholder="0 to {{indexMax}}" autocomplete="off">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="uk-width-1-1 narrow-div">
            <div class="uk-form-horizontal">
              <div class="uk-margin">
                <label class="uk-form-label" for="max-incoming">Max Incoming Tx's <span uk-icon="icon: info;" uk-tooltip title="Maximum number of incoming transactions to receive on each source account before sweeping. 0 is allowed. You can also use the 'Min Receive' in the app settings to get rid of spam. If not enough, you can just run the process multiple times."></span></label>
                <div class="uk-form-controls">
                  <div class="uk-inline uk-width-1-1">
                    <input [(ngModel)]="maxIncoming" class="uk-input uk-margin-small-bottom {{validMaxIncoming ? '':'uk-form-danger'}}" id="max-incoming" type="text" maxLength="10" (ngModelChange)="maxIncomingChange(maxIncoming)" placeholder="0 to {{incomingMax}}" autocomplete="off">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="uk-width-1-1 narrow-div">
            <button *ngIf="!sweeping" class="uk-button uk-button-primary uk-width-1-1" type="button" [disabled]="!settings.settings.serverAPI" (click)="sweep()">{{settings.settings.serverAPI ? 'START SWEEPING':'NOT AVAILABLE IN OFFLINE MODE'}}</button>
            <button *ngIf="sweeping" class="uk-button uk-button-primary uk-disabled uk-width-1-1" type="button"><span class="uk-margin-right" uk-spinner></span> PROCESSING...</button>
          </div>
        </div>
      </div>
    </div>

    <div class="uk-width-1-1">
      <textarea [(ngModel)]="output" rows="4" readOnly #outputarea class="uk-input uk-margin-small-bottom" placeholder="The output log will be visible here"></textarea>   
    </div>
  </div>
</div>
